import React from "react";
import { defaultBoxShadow } from "../../lib/language/constantStyle";
import OurSolutions from "../../lib/Json/homePage.json";
import {
  IoCafeOutline,
  IoFitnessOutline,
  IoBookOutline,
} from "react-icons/io5";
import { IoRestaurantOutline } from "react-icons/io5";
import { TbTruckDelivery } from "react-icons/tb";
import { LuCakeSlice } from "react-icons/lu";
import { BiDrink } from "react-icons/bi";
import { BsShopWindow } from "react-icons/bs";
import { MdOutlineShoppingBag } from "react-icons/md";
import AnimatedElement from "../../components/content/textAnimation/page";

function Solutions() {
  const iconMapping = {
    IoRestaurantOutline: IoRestaurantOutline,
    IoCafeOutline: IoCafeOutline,
    TbTruckDelivery: TbTruckDelivery,
    LuCakeSlice: LuCakeSlice,
    IoFitnessOutline: IoFitnessOutline,
    BiDrink: BiDrink,
    IoBookOutline: IoBookOutline,
    BsShopWindow: BsShopWindow,
    MdOutlineShoppingBag: MdOutlineShoppingBag,
  };
  return (
    <div className="w-3/4 m-auto">
      <div className="flex items-end text-gray-600 poppins_semibold gap-2">
        <span className="text-gray-500 text-xl tracking-wide">Our</span>
        <p className="w-28 h-0.5 bg-yellow-400 mb-1" />
      </div>
      <h2 className="poppins_semibold text-3xl tracking-widest shining-animation">
        Solutions
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {OurSolutions?.solutions?.map((item, index) => {
          const IconComponent = iconMapping[item.icon];
          return (
            <AnimatedElement
              animationClass="animate__fadeInDown"
              delay={index + 100}
            >
              <div className="p-4 h-full md:h-80">
                <div
                  className={`${defaultBoxShadow} flex rounded-lg h-full p-8 flex-col`}
                >
                  <div className="flex flex-col items-center mb-3">
                    <div className="p-4 inline-flex items-center justify-center bg-[#f6892f] text-white rounded-md mb-3">
                      {item.type === "icon" ? (
                        <IconComponent size="20px" />
                      ) : (
                        <img
                          src={item.imageUrl}
                          alt={item.title}
                          className="w-6 h-6"
                        />
                      )}
                    </div>
                    <h2 className="text-gray-900 text-md md:text-md title-font poppins_medium">
                      {item.title}
                    </h2>
                  </div>
                  <div className="flex-grow">
                    <p className="leading-relaxed text-xs md:text-sm text-center poppins_light">
                      {item.content}
                    </p>
                  </div>
                </div>
              </div>
            </AnimatedElement>
          );
        })}
      </div>
    </div>
  );
}

export default Solutions;
